import {rem, createStyles, Container, Button} from '@mantine/core';
import {IconArrowRight} from '@tabler/icons-react';
import {Carousel} from '@mantine/carousel';

const useStyles = createStyles(theme => ({
  hero: {
    position: 'relative',
    backgroundImage: 'url(./assets/img/join-us.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  container: {
    height: rem(750),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    paddingBottom: `calc(${theme.spacing.xl} * 6)`,
    zIndex: 1,
    position: 'relative',

    [theme.fn.smallerThan('sm')]: {
      height: rem(500),
      paddingBottom: `calc(${theme.spacing.xl} * 3)`,
    },
  },
}));

function Hero() {
  const {classes} = useStyles();

  return (
    <>
      <Carousel
        mx="auto"
        withIndicators
        loop
        height={750}
        breakpoints={[
          {maxWidth: 'md', slideSize: '50%'},
          {maxWidth: 'sm', slideSize: '100%', slideGap: 0},
        ]}
      >
        <Carousel.Slide>
          {' '}
          <div className=" bg-image">
            {/*<Overlay
          gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 50%)"
          opacity={1}
          zIndex={0}
        />*/}
            <Container className={classes.container}>
              <h1 className="page-title top-a overlay2 overlay_1">
                We offer quality care in your home
              </h1>
              <div className="slide-brief animated overlay overlay_1">
                <p className="top-a ">
                  Our dedicated and experienced local care and office teams are
                  committed to delivering a personalised care service for our
                  clients.
                </p>
              </div>
              <div className="btn-wrapper animated">
                <Button
                  component="a"
                  href="/about-quality"
                  rel="noopener noreferrer"
                  leftIcon={<IconArrowRight size={rem(18)} />}
                  styles={theme => ({
                    root: {
                      backgroundColor: '#21485e',
                      border: 0,

                      '&:not([data-disabled])': theme.fn.hover({
                        backgroundColor: '#21485e',
                        color: '#ffffff',
                      }),
                    },

                    leftIcon: {
                      marginRight: theme.spacing.md,
                    },
                  })}
                >
                  Read more
                </Button>
              </div>
            </Container>
          </div>
        </Carousel.Slide>
        <Carousel.Slide>
          {' '}
          <div className=" bg-image-2">
            {/*<Overlay
          gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 50%)"
          opacity={1}
          zIndex={0}
        />*/}
            <Container className={classes.container}>
              <h1 className="page-title top-a overlay2 overlay_1">
                Recruiting highly dedicated individuals
              </h1>
              <div className="slide-brief animated  overlay overlay_1">
                <p className="top-a">
                  Join our team of skilled and experienced individuals dedicated
                  to delivering high quality complex care at home.
                </p>
              </div>
              <div className="btn-wrapper animated">
                <Button
                  component="a"
                  href="/work-with-us"
                  rel="noopener noreferrer"
                  leftIcon={<IconArrowRight size={rem(18)} />}
                  styles={theme => ({
                    root: {
                      backgroundColor: '#21485e',
                      border: 0,

                      '&:not([data-disabled])': theme.fn.hover({
                        backgroundColor: '#21485e',
                        color: '#ffffff',
                      }),
                    },

                    leftIcon: {
                      marginRight: theme.spacing.md,
                    },
                  })}
                >
                  Work with us
                </Button>
              </div>
            </Container>
          </div>
        </Carousel.Slide>
        <Carousel.Slide>
          {' '}
          <div className=" bg-image-3">
            {/*<Overlay
          gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 50%)"
          opacity={1}
          zIndex={0}
        />*/}
            <Container className={classes.container}>
              <h1 className="page-title top-a overlay2 overlay_1">
                We provide Complex Care across the UK
              </h1>
              <div className="slide-brief animated overlay overlay_1">
                <p className="top-a">
                  Our dedicated and experienced local care and office teams are
                  committed to delivering a personalised care service for our
                  clients across the UK.
                </p>
              </div>
              <div className="btn-wrapper animated">
                <Button
                  component="a"
                  href="/our-care"
                  rel="noopener noreferrer"
                  leftIcon={<IconArrowRight size={rem(18)} />}
                  styles={theme => ({
                    root: {
                      backgroundColor: '#21485e',
                      border: 0,

                      '&:not([data-disabled])': theme.fn.hover({
                        backgroundColor: '#21485e',
                        color: '#ffffff',
                      }),
                    },

                    leftIcon: {
                      marginRight: theme.spacing.md,
                    },
                  })}
                >
                  Find out more
                </Button>
              </div>
            </Container>
          </div>
        </Carousel.Slide>
      </Carousel>
    </>
  );
}

export default Hero;
